module.exports = __webpack_public_path__ + "img/pose-m-5.d5c87c8c.png";